/**
 * dataLayer push and ensure – shared by turnstile, utm-tracker, event-tracker.
 * @package AdvancedTrackingManager
 */

/**
 * Ensure global dataLayer array exists.
 */
export const ensureDataLayer = (): void => {
  const w = globalThis as unknown as Window;
  if (typeof w.dataLayer === 'undefined') {
    w.dataLayer = [];
  }
};

/**
 * Push an event (and optional data) to dataLayer.
 */
export const pushEvent = (name: string, data?: Record<string, unknown>): void => {
  ensureDataLayer();
  const payload = data ? { event: name, ...data } : { event: name };
  (globalThis as unknown as Window).dataLayer!.push(payload);
};

